/*
 * @Author: sillyy
 * @Date: 2019-02-14 14:11:28
 * @LastEditors: shero
 * @LastEditTime: 2019-03-26 14:36:17
 * @Description:
 */
import {
  PTeacherList,
  PGetTeacherById,
  TTeacherInfo,
  PResetTeacherPwd,
  PGetCoursePageByTeacherId,
  TTeacherAddForm,
  TManageInfo,
  TConsuptionSearch,
  TApplyRebackCoursePackage,
  TCancelRebackCoursePackage,
  TReturnSearch,
  TRefuseRebackCoursePackage,
  TLeadsSearch,
  PLeadsRemark,
  TAddLeadsRemark,
  TLeadsDetailForm,
  PGetLeads,
  TProjectSearch,
  TCourse_Search,
  TOrgList  // add by_ALi
} from '@/types/views/school'
import request from '@/utils/request'
import request_B from '@/utils/request_B'
import util from '@/utils'

/**
 * 获取老师列表
 * @param {PTeacherList} options 参数
 */
export function getTeacherList(options: PTeacherList) {
  return request('/org/getOrgTeacherByPage', options)
}

// 获取所属校区下拉框内容 add by_ALi
export function getOrgList(options: TOrgList) {
  return request('/org/getOrgInfoByPage', options)
}

/**
 * 获取校区管理列表内容 add by_ALi
 * @param {any} options 参数
 */
export function getOrgByPage(options: any): any {
  return request_B('/orgCenter/getOrgByPage', options)
}

/**
 * 获取老师详情
 * @param {PGetTeacherById} options 参数
 */
export function getTeacherById(options: PGetTeacherById) {
  return request('/course/getTeacherById', options)
}

/**
 * 更新老师信息
 * @param {TTeacherInfo} options 参数
 */
export function updateTeacher(options: any) {
  return request('/org/upateTeacher', options, 'POST', true)
}

/**
 * 重置老师密码
 * @param {PResetTeacherPWd} options 参数
 */
export function resetTeacherPwd(options: PResetTeacherPwd) {
  return request('/org/resetTeacherPwd', options, 'POST', true)
}

/**
 * 获取指定老师课程列表-Page
 * @param {PGetCoursePageByTeacherId} options 参数
 */
export function getCoursePageByTeacherId(options: PGetCoursePageByTeacherId) {
  return request('/org/getCoursePageByTeacherId', options)
}

/**
 * 新增老师
 * @param {TTeacherAddForm} options 参数
 */
export function addTeacher(options: TTeacherAddForm) {
  return request('/org/addNewTeacher', options, 'POST')
}

/**
 * 获取市场拓展包
 */
export function getExtensionPackage() {
  return request('/org/getExtensionPackage')
}

/**
 * 获取培训视频列表
 *  @param {any} options 参数
 */
export function getTrainingVideoList(options: any) {
  return request('/org/getTrainingVideoList', options, 'post')
}

/**
 * 获取机构信息
 */
// export function getOrgInfo(options?: any): any {
//   return request('/org/getOrgInfo', options, 'get')
// }
export function getOrgInfo(options?: any): any {
  return request_B('/orgCenter/getOrgInfo', options, 'get')
}

/**
 * 更新机构信息
 * @param {TManageInfo} options 参数
 */
export function upDateOrgInfo(options: TManageInfo) {
  return request('/org/upateOrgInfo', options, 'post')
}

/**
 * 课程包消耗列表
 * @param {TConsuptionSearch} options 参数
 */
export function getCoursePackagePage(options: TConsuptionSearch) {
  return request(
    '/coursePackage/getCoursePackagePage',
    util.encParam(options),
    'get'
  )
}

/**
 * 同意申请课程包退还
 * @param {TApplyRebackCoursePackage} options 参数
 */
export function applyRebackCoursePackage(options: TApplyRebackCoursePackage) {
  return request(
    '/rebackCoursepackage/applyRebackCoursePackage',
    options,
    'get'
  )
}

/**
 * 驳回申请课程包退还
 * @param {TRefuseRebackCoursePackage} options 参数
 */
export function refuseRebackCoursePackage(options: TRefuseRebackCoursePackage) {
  return request(
    '/rebackCoursepackage/refuseRebackCoursePackage',
    options,
    'get'
  )
}

/**
 * 撤销课程包返回申请
 * @param {TCancelRebackCoursePackage} options 参数
 */
export function cancelRebackCoursePackage(options: TCancelRebackCoursePackage) {
  return request(
    '/rebackCoursepackage/cancelRebackCoursePackage',
    options,
    'get'
  )
}

/**
 * 获取返还申请列表
 * @param {TReturnSearch} options 参数
 */
export function getRebackCoursePackagePage(options: TReturnSearch) {
  return request(
    '/rebackCoursepackage/getRebackCoursePackagePage',
    util.encParam(options),
    'get'
  )
}

/**
 * B端的leads表
 * @param {TLeadsSearch} options 参数
 */
export function getLeadsPage(options: TLeadsSearch) {
  return request('/leads/getBLeadsPage', util.encParam(options), 'post')
}

/**
 * @description: 查看B端leads详情
 * @param {PGetLeads} options 参数
 */
export function getLeads(options: PGetLeads) {
  return request('/leads/getBLeadsById', options, 'get')
}
/**
 * @description: 更新B端leads详情
 * @param {TLeadsDetailForm} options 参数
 */
export function updateLeads(options: TLeadsDetailForm) {
  return request('/leads/updateBLeads', options, 'post')
}

/**
 * B端的备注列表
 * @param {PLeadsRemark} options 参数
 */
export function getLeadsRemark(options: PLeadsRemark) {
  return request('/leads/getBLeadsRemark', options, 'get')
}

/**
 * 保存B端备注
 * @param {TAddLeadsRemark} options 参数
 */
export function addLeadsRemark(options: TAddLeadsRemark) {
  return request('/leads/addBLeadsRemark', options, 'post')
}

/**
 * @description: b端leads作品列表
 * @param {TProjectSearch} options 参数
 */
export function getProjectPage(options: TProjectSearch) {
  return request('/project/getProjectPage', options, 'get')
}

/**
 * @description: b端leads课程列表
 * @param {TCourse_Search} options 参数
 */
export function getCoursePage(options: TCourse_Search) {
  return request('/course/getCoursePage', options, 'get')
}

/**
 * @description: 根據条件查询分校机构信息
 * @param {any} options 参数
 */
export function getBranchPage(options: any): any {
  return request('/branch/getBranchPage', options, 'get')
}

// --- 耕子端老接口 add_ALi   start
// 根据机构 Id 查看分校详情
export function getBranchDetail(options: any) {
  return request('/branch/getBranchDetail', options, 'get')
}
// 学校更新
export function updateSchool(options: any) {
  return request('/org/upateOrgInfo', options, 'post', true)
}
// 分校查看总校可分配的激活码列表
export function getOrgAssignActivation(options: any) {
  return request('/orgActivation/getOrgAssignActivation', options, 'get')
}
// 账户密码重置
export function resetAccountPassword(options: any) {
  return request('/account/resetPassword', options, 'post')
}
// 总校给分校分配激活码
export function assignActivation(options: any) {
  return request('/orgActivation/assignActivation', options, 'get')
}
// end

// 查询激活码列表
export function getActivationList(options: any) {
  return request('/orgActivation/getActivationList', options, 'get')
}

// 新增或者修改激活码
export function modifyActivation(options: any) {
  return request('/orgActivation/modifyActivation', options, 'get')
}

// 查看该验证码下已绑定的设备
export function getActivationbindList(options: any) {
    return request('/orgActivation/getActivationbindList', options, 'get')
}

// 绑定校验或者解绑激活码
export function modifyBindInfo(options: any) {
  return request('/orgActivation/modifyBindInfo', options, 'get')
}